import React, { useCallback } from "react";
import styles from "./Toggle.module.scss";
import clsx from "clsx";

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  dataContentPiece: string;
}

export const Toggle: React.FC<React.PropsWithChildren<ToggleProps>> = ({
  checked,
  onChange,
  label,
  dataContentPiece
}) => {
  const onClick = useCallback(() => {
    onChange(!checked);
  }, [checked, onChange]);

  // This is needed so that we can "cancel" the click event when we use the `Enter` key on a button.
  const handleKeyPress = useCallback(
    (event: React.KeyboardEvent<HTMLButtonElement>) => event.preventDefault(),
    []
  );

  const handleKeyUp = useCallback(
    (event: React.KeyboardEvent<HTMLElement>) => {
      if (event.key !== "Tab") event.preventDefault();
      if (event.key === " ") onClick();
    },
    [onClick]
  );
  return (
    <div className={styles.container}>
      <button
        tabIndex={0}
        role="switch"
        aria-checked={checked}
        aria-label={label}
        onClick={onClick}
        onKeyDown={handleKeyPress}
        onKeyUp={handleKeyUp}
        className={clsx(styles.toggle, {
          [styles.toggleChecked]: checked
        })}
        data-content-piece={dataContentPiece}
      >
        <span
          aria-hidden="true"
          className={clsx(styles.selector, {
            [styles.selectorChecked]: checked
          })}
        />
      </button>
      {label && <div className={styles.label}>{label}</div>}
    </div>
  );
};
